import * as Yup from 'yup';

export const shippingEditSchema = Yup.object({
  name: Yup.string().required('Campo obrigatório'),
  transport: Yup.string().required('Campo obrigatório'),
  status: Yup.string().required('Campo obrigatório'),
});
